import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PricingService } from '@shared/services/pricing.service';
import { ShipmentService } from '@shared/services/shipment.service';
import { Store } from '@ngrx/store';
import { AppState } from '@shared/redux/config-store-state.model';
import { BookMerge } from '@shared/services/cart-storage.service';

@Component({
  selector: 'astrea-cart-summary',
  templateUrl: './cart-summary.component.html',
  styleUrls: ['./cart-summary.component.scss']
})
export class CartSummaryComponent implements OnInit {

  public books: BookMerge[] = [];
  public totalPhysical: number = 0;
  public totalDigital: number = 0;

  @Output() changeTab = new EventEmitter<number>();

  @Input() isLoggedIn!: boolean;

  @Input() physicalBooks: BookMerge[] = [];
  @Input() digitalBooks: BookMerge[] = [];

  @Input() set booksMerge(books: BookMerge[]) {
    this.books = books;
    this.prepareBooks();
  };

  constructor(
    public pricingService: PricingService,
    public shipmentService: ShipmentService,
    private store: Store<AppState>,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.store.select(state => state.storeConfig.currency)
      .subscribe({
        next: () => {
          this.prepareBooks();
        }
      });
  }

  prepareBooks(): void {
    this.totalPhysical = 0;
    this.totalDigital = 0;
    this.books.forEach((b: BookMerge) => {
      if (b.cartInfo.typeStorage == 'physical_book')
        this.totalPhysical += this.pricingService.getWebPricing(b.bookInfo) * b.cartInfo.count;
      else if (b.cartInfo.typeStorage == 'digital_book')
        this.totalDigital += this.pricingService.getAVPricing(b.bookInfo) * b.cartInfo.count;
    });
  }

  handleChangeTab(tab: number): void {
    if (this.isLoggedIn) {
      this.changeTab.emit(tab);
    } else {
      this.router.navigate(['/login'], { queryParams: { redirect: `cart` } });
    }
  }

}
